import { Children, cloneElement, createElement } from 'react';

const Column = ({ children, className = "", style = {}, noClone = false, ...props }) => createElement("div", { className: `column ${className}`, style }, Children.map(children, (child) => noClone ? child : cloneElement(child, props)));

Column.displayName = 'Column';

export default Column;